"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));

var _ReactHTML = _interopRequireDefault(require("@micado-digital/react-html/ReactHTML"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Payment01 = function Payment01() {
  var _systemLink;

  var _useParams = (0, _reactRouterDom.useParams)(),
      paymentID = _useParams.id,
      paymentType = _useParams.type;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      id = _useState2[0],
      setID = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      type = _useState4[0],
      setType = _useState4[1];

  var systemLink = (0, _useSystemLinks.default)();
  var confirmationUrl = (_systemLink = systemLink("shop-payment-success")) !== null && _systemLink !== void 0 ? _systemLink : "/";
  var location = window.location.href;
  (0, _react.useEffect)(function () {
    var _segments$length;

    var segments = location.split("/");
    var segmentsLength = (_segments$length = segments === null || segments === void 0 ? void 0 : segments.length) !== null && _segments$length !== void 0 ? _segments$length : 0;
    setID(encodeAndReplaceID(paymentID !== null && paymentID !== void 0 ? paymentID : segments === null || segments === void 0 ? void 0 : segments[segmentsLength - 1]));
    setType(paymentType !== null && paymentType !== void 0 ? paymentType : segments === null || segments === void 0 ? void 0 : segments[segmentsLength - 2]);
  }, [location, paymentID, paymentType]);

  var encodeAndReplaceID = function encodeAndReplaceID(id) {
    if (!id) return;
    return encodeURI(id.replace("####", "."));
  };

  if (id && type === "hobex") {
    return /*#__PURE__*/_react.default.createElement(_Container.default, {
      className: "mco-shop-payment",
      maxWidth: "lg"
    }, /*#__PURE__*/_react.default.createElement(_ReactHTML.default, {
      html: "<script src=\"https://oppwa.com/v1/paymentWidgets.js?checkoutId=".concat(id, "\"></script><form action=\"").concat(confirmationUrl, "\" class=\"paymentWidgets\" data-brands=\"VISA MASTER MAESTRO PAYPAL VPAY SOFORTUEBERWEISUNG\"></form>")
    }));
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

Payment01.propTypes = {};
var _default = Payment01;
exports.default = _default;